import {
  type HighFrequency_DrawStatus,
  HighFrequency_DrawStatusEnum,
  type HighFrequency_DrawStatusNotOperating,
  type HighFrequency_DrawStatusPending,
  type HighFrequency_DrawStatusReady,
} from '#api/shared/@types/generated/backend/graphql-schema-types'
import { includesIgnoreCase } from '~/utils/array'

import { HFG_POSSIBLE_BONUS_ADD_ONS } from './highFrequencyGameConstants'

export const isHighFrequencyBonusNumber = (fieldName: string) =>
  includesIgnoreCase(HFG_POSSIBLE_BONUS_ADD_ONS, fieldName)

export const isPendingStatus = (
  drawStatus: HighFrequency_DrawStatus,
): drawStatus is HighFrequency_DrawStatusPending =>
  drawStatus.status === HighFrequency_DrawStatusEnum.Pending

export const isNotOperating = (
  drawStatus: HighFrequency_DrawStatus,
): drawStatus is HighFrequency_DrawStatusNotOperating =>
  drawStatus.status === HighFrequency_DrawStatusEnum.NotOperating

export const isReadyStatus = (
  drawStatus: HighFrequency_DrawStatus,
): drawStatus is HighFrequency_DrawStatusReady =>
  drawStatus.status === HighFrequency_DrawStatusEnum.Ready
